import { render, staticRenderFns } from "./Searches.vue?vue&type=template&id=409a0f39&"
import script from "./Searches.vue?vue&type=script&lang=js&"
export * from "./Searches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports